import { useQuery, useMutation } from "@tanstack/react-query";
import { api } from "lib/api";

// GET /perfil/registro/context
export function usePerfilRegistroContext() {
  return useQuery({
    queryKey: ["perfil", "registro", "context"],
    queryFn: () => api("/perfil/registro/context"),
    staleTime: 30_000,
  });
}

export function usePerfilSocioOverview(socioId, enabled = true) {
  return useQuery({
    queryKey: ["perfil", "registro", "socio-overview", socioId],
    queryFn: () => api(`/perfil/registro/socios/${socioId}/overview`),
    enabled: enabled && Boolean(socioId),
    staleTime: 30_000,
  });
}

// POST /perfil/registro/club
export function useRegisterClub() {
  return useMutation({
    mutationFn: ({ socioId }) =>
      api("/perfil/registro/club", {
        method: "POST",
        body: JSON.stringify({ socioId }),
      }),
  });
}

// POST /perfil/registro/camp
export function useRegisterCamp() {
  return useMutation({
    mutationFn: ({ socioId, talla }) =>
      api("/perfil/registro/camp", {
        method: "POST",
        body: JSON.stringify({ socioId, talla }),
      }),
  });
}
